import { useTheme } from '@mui/material/styles';
import { ThemeMode } from '../../types/config';
import { FC } from 'react';
import DarkLogo from '../../assets/images/logo-dark.svg';
import LightLogo from '../../assets/images/logo-light.svg';
import { Box } from '@mui/material';

const LogoMain: FC<{ reverse?: boolean }> = ({ reverse, ...others }) => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				height: 16,
				svg: {
					width: 'auto',
					height: 16,
				},
			}}
		>
			{theme.palette.mode === ThemeMode.DARK ? <DarkLogo /> : <LightLogo />}
		</Box>
	);
};

export default LogoMain;
